import WorkoutIndicator from './WorkoutIndicator';

export default WorkoutIndicator;
